import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import routeTable from '../../../../../utility/routeTable';
import {
  ConstantContactService,
  MailingList,
} from '../../../../../services/constant-contact.service';
import { FormControl, Validators } from '@angular/forms';
import { AppValidators } from '../../../../../core/validators/app-validators';
import { Router } from '@angular/router';
import constants from '../../../../../utility/constants';
import { ToastrService } from 'ngx-toastr';
import {  Subscription } from 'rxjs';
@Component({
  selector: 'app-public-footer',
  templateUrl: './public-footer.component.html',
  styleUrls: ['./public-footer.component.css'],
})
export class PublicFooterComponent {
  routes = routeTable.public;
  currentYear = new Date().getFullYear();
  private subscriptions: Array<Subscription> = [];
  modalRef: BsModalRef;
  maxlengthShorter: number = constants.common.validations.maxLength50;
  emailSubscription: FormControl = new FormControl(null, [
    Validators.required,
    AppValidators.checkEmail,
    Validators.maxLength(this.maxlengthShorter),
  ]);
  mailingList: Array<MailingList>;
  selectedMailList: Array<string> = [];

  loading: boolean = false;

  config = {
    ignoreBackdropClick: true,
    class: 'custom-popup modal-dialog modal-dialog-centered subscribe-popup',
  };

  constructor(
    private router: Router,
    private modalService: BsModalService,
    private constantContact: ConstantContactService,
    private toastr: ToastrService
  ) {}

  async ngAfterViewInit() {
    await this.callConstantContact();
  }

  openModal(template: TemplateRef<any>) {
    let ccHtml = document.getElementById('cc-subscribeform');
    let inputEmail = document.getElementById('sub-footer-input');
    const clone = ccHtml.cloneNode(true) as HTMLElement;
    let inputs = clone.getElementsByClassName("ctct-form-element");
    [].forEach.call(inputs, x => {
      //@ts-ignore
      x.value = inputEmail.value;
    })
    clone.removeAttribute('style');
    clone.setAttribute('style', 'display: block;')
    this.modalRef = this.modalService.show(template, this.config);
    let subscribeModalBody = document.getElementById('subscribeModal-body-footer');
    subscribeModalBody.append(clone)
  }

  closeModal() {
    if (this.modalRef) {
      let ccHtml = document.getElementById('cc-subscribeform');
      const clone = ccHtml.cloneNode(true) as HTMLElement;
      clone.removeAttribute('style');
      clone.setAttribute('style', 'display: none;')
      this.modalRef.hide();
    }
  }

  checkItem(isChecked: boolean, listId: string) {
    if (isChecked) this.selectedMailList.push(listId);
    else
      this.selectedMailList.splice(
        this.selectedMailList.findIndex((i) => i === listId),
        1
      );
  }

  async callConstantContact(): Promise<any> {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.setAttribute("id","cc-script")
      script.src = '//static.ctctcdn.com/js/signup-form-widget/current/signup-form-widget.min.js';
      script.setAttribute("type", "text/javascript");
      script.onload = resolve;
      script.onerror = function () {
        reject(new Error("Cannot load script at: ".concat(script.src)));
      };
      var footer = document.getElementsByTagName("footer")[0];
      footer.appendChild(script);
      })
  }


  subscribe() {
    this.loading = true;
    const subscribeList = this.constantContact
      .subscribeToListing(this.emailSubscription.value, this.selectedMailList)
      .subscribe(
        (res) => {
          if (res) this.closeModal();
          this.selectedMailList = [];
          this.toastr.success(
            'You can unsubscribe at any time using the Unsubscribe link at the bottom of every email.',
            'Thanks for signing up!',
            constants.common.toast.config
          );
          this.loading = false;
          this.emailSubscription.reset();
        },
        (err) => {
          this.loading = false;
        }
      );
      this.subscriptions.push(subscribeList)
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
